import React from "react";

const DrawerContext = React.createContext();

export default DrawerContext;
